import { CreateRenderFunction, NextFrame } from "@pdfking/reactivity/preact"
import { Items, Keys } from "@pdfking/tfunc"
import { RootMixin } from "@pdfking/workflow/mixins/RootMixin"
import fire_event from "@pdfking/workflow/utils/fire_event"
import make_translations from "@pdfking/workflow/utils/make_translations"
import selector from "../../dom/selector"
import { CloseMixin } from "../../mixins/Close"
import { FreezeMixin } from "../../mixins/Freeze"
import cx from "../../utils/cx"

export const Prompt = CreateRenderFunction({
  computed: {
    actual_default_button() {
      const button_keys = Keys(this.buttons)
      return this.default_button || button_keys[button_keys.length - 1]
    },
    translations: () => make_translations("actions"),
  },
  props: {
    buttons: {} as Record<string, string>,
    default_button: "" as string,
    id: "" as string,
    message_name: "" as string,
    title: "" as string,
  },
  data: {
    toggled_class: "modal-body",
    user_message: "",
  },

  methods: {
    get_button_class(key: string, _index: number) {
      return key === this.actual_default_button
        ? "btn-primary"
        : "btn-outline-primary"
    },
    handle_close(button_key: string | null = null) {
      fire_event(document, "alert-dialog-result", {
        id: this.id,
        message: this.user_message,
        result: button_key,
      })
      this.close()
    },
  },

  mixins: [CloseMixin, FreezeMixin, RootMixin],

  mounted() {
    NextFrame(() =>
      selector(".btn-primary", this.root).forEach((b: Element) =>
        (b as HTMLButtonElement).focus()
      )
    )
  },

  render() {
    return (
      <div
        class="modal fade show opacity-100 d-flex align-items-center justify-content-center"
        style="background-color: rgba(0, 0, 0, 0.5)"
        onClick={() => this.handle_close()}
      >
        <div
          class="modal-dialog modal-dialog-centered"
          onClick={(e: Event) => e.stopPropagation()}
        >
          <div class="modal-content">
            <div class="modal-body">
              {this.title}
              {this.message_name && (
                <textarea
                  value={this.user_message}
                  onInput={(e: Event) => {
                    this.user_message = (e.target as HTMLTextAreaElement).value
                  }}
                  class="form-control mt-3"
                  cols={40}
                  placeholder={this.message_name}
                  rows={5}
                />
              )}
            </div>

            <div class="modal-footer">
              {Items(this.buttons).map(
                ([key, label]: [string, any], index: number) => (
                  <button
                    key={key}
                    class={cx("btn", this.get_button_class(key, index))}
                    type="button"
                    onClick={() => this.handle_close(key)}
                  >
                    {label}
                  </button>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    )
  },
})
